//Трекеры для обнволения с сервером
const syncTimers = {};
const lastStates = {};

import { getUserBriefcase } from "@/Groups/Briefcase/private/api/getUserBriefcase";
import { addCoinToBriefcase } from "@/Groups/Briefcase/private/api/addCoinToBriefcase";
import { deleteCoinFromBriefcase } from "@/Groups/Briefcase/private/api/deleteCoinFromBriefcase";
import { changeCoinIndex } from "@/Groups/Briefcase/private/api/changeCoinIndex";

const Briefcase = {
  namespaced: true,

  state: {
    assets: [],
    pendingAssets: [],
    isLoadingAssets: false,
    isCoinSearchOpened: false,
    isEditing: false,
    isReady: false,
  },

  actions: {
    togglePendingAsset({ commit }, coin) {
      commit('TOGGLE_PENDING_ASSET', coin);
    },

    async syncPendingAssets({ state, commit, dispatch }) {
      const assetsInBriefcase = state.assets.map(a => a.coin.api_id);
      const promises = [];

      for (const coin of state.pendingAssets) {
        const isInBriefcase = assetsInBriefcase.includes(coin.api_id);
        if (!isInBriefcase) {
          promises.push(addCoinToBriefcase(coin.api_id));
          commit('TOGGLE_ASSET', coin);
        } else {
          promises.push(deleteCoinFromBriefcase(coin.api_id));
          commit('TOGGLE_ASSET', coin);
        }
      }
      dispatch('toggleSearchSection', false); 
      try {
        await Promise.all(promises);
      } catch (err) {
        console.error('Error syncing pending assets:', err);
      }
      commit('CLEAR_PENDING_ASSETS');
    },

    toggleAsset({ commit, state }, coin) {
      const apiId = coin.api_id;
      const wasInAssets = state.assets.some(el => el.coin.api_id === apiId);
      //1.Мгновенно бновим UI
      commit('TOGGLE_ASSET', coin);
      //2.Сохраняем "последнее состояние" для сравнения позже
      lastStates[apiId] = !wasInAssets;
      //3.Если пользователь повторно кликает — сбросить предыдущий таймер
      if (syncTimers[apiId]) {
        clearTimeout(syncTimers[apiId]);
      }
      //4.Установить новый debounce таймер
      syncTimers[apiId] = setTimeout(async () => {
        const isNowInAssets = state.assets.some(el => el.coin.api_id === apiId);
        //5. Если состояние изменилось по сравнению с тем, что было ДО клика — отправляем
        if (isNowInAssets !== wasInAssets) {
          try {
            (isNowInAssets) ? await addCoinToBriefcase(coin.api_id) : await deleteCoinFromBriefcase(coin.api_id);
          } catch (err) {
            console.error("Sync error:", err);
          }
        }
        delete syncTimers[apiId];
        delete lastStates[apiId];
      }, 1000); 
    },

    toggleSearchSection({ commit }, status){
      commit('SET_SEARCH_SECTION_OPENED_FLAG', status);
    },
    
    async getAssets({ commit, state }){
      commit('SET_LOADING_FLAG', true);
      const data = await getUserBriefcase();
      commit('SET_READY_FLAG');
      commit('SET_ASSETS', data.assets);
      commit('SET_LOADING_FLAG', false);
    },

    async moveAsset({ commit, state }, { from, to }) {
      if (from === to) return;

      const assets = [...state.assets];
      const movedItem = assets.splice(from, 1)[0];
      assets.splice(to, 0, movedItem);

      // Переиндексация и выявление изменений
      const updatedIndexes = [];
      assets.forEach((el, i) => {
        if (el.index !== i) {
          el.index = i;
          updatedIndexes.push({ api_id: el.coin.api_id, index: i });
        }
      });

      commit('SET_ASSETS', assets);

      try {
        await Promise.all(updatedIndexes.map(({ api_id, index }) =>
          changeCoinIndex(api_id, index)
        ));
      } catch (err) {
        console.error('Failed to sync moved indexes:', err);
      }
    },
    
    toggleEditing({ state, commit }){
      commit('SET_EDITING_FLAG', state.isEditing ? false : true);
    }
  },

  mutations: {
    SET_ASSET(state, data){ state.assets.shift(data); },

    SET_READY_FLAG(state){ state.isReady = true; },

    SET_EDITING_FLAG(state, status){ state.isEditing = status; },

    SET_ASSETS(state, data){ state.assets = data; },

    SET_LOADING_FLAG(state, status){ state.isLoadingAssets = status; },

    SET_SEARCH_SECTION_OPENED_FLAG(state, status){ state.isCoinSearchOpened = status; },

    TOGGLE_PENDING_ASSET(state, coin) {
      const idToToggle = String(coin.api_id);
      const index = state.pendingAssets.findIndex(c => String(c.api_id) === idToToggle);
      if (index !== -1) {
        state.pendingAssets.splice(index, 1);
      } else {
        state.pendingAssets.push(coin);
      }
    },

    CLEAR_PENDING_ASSETS(state) {
      state.pendingAssets = [];
    },

    TOGGLE_ASSET(state, coin) {
      const foundIndex = state.assets.findIndex(el => el.coin.api_id === coin.api_id);
      if (foundIndex !== -1) {
        state.assets.splice(foundIndex, 1);
        state.assets.forEach((el, idx) => {
          el.index = idx;
        });
      } else {
        state.assets.push({
          index: state.assets.length,
          coin
        });
      }
    }
  },

  getters: {
    sortedAssets(state) {
      return [...state.assets].sort((a, b) => a.index - b.index);
    }
  }

}

export default Briefcase;